import { useState, useEffect, useCallback } from "react";
import { vehicleGroupService } from "../Services/vehicle.group.service";
import { vehicleService } from "../Services/vehicle.service";
import { fuelService } from "../Services/fuel.service";


const normalizeFuelTypes = (data) =>
  (Array.isArray(data) ? data : []).map((ft) => ({
    fuelTypeId:          ft.FuelTypeId          ?? ft.fuelTypeId          ?? ft.id ?? 0,
    fuelTypeDescription: ft.FuelTypeDescription ?? ft.fuelTypeDescription ??
                         ft.name ?? ft.fuelTypeName ?? ft.description     ?? "—",
    infoCarIndicator:    ft.InfoCarIndicator     ?? ft.infoCarIndicator    ?? null,
  }));


const normalizeRefuelings = (data) =>
  (Array.isArray(data) ? data : []).map((r) => ({
    ...r,
    refuelingId:   r.RefuelingId   ?? r.refuelingId   ?? r.id,
    refuelingDate: r.RefuelingDate ?? r.refuelingDate ?? r.dateTime ?? r.date,
    fuelTypeName:  r.FuelTypeDescription ?? r.fuelTypeDescription ??
                   r.fuelTypeName ?? r.FuelTypeName ?? r.combustivel ?? "—",
    quantity:      r.Quantity ?? r.quantity ?? r.quantidade ?? 0,
    amount:        r.Amount   ?? r.amount   ?? r.Value ?? r.value ?? 0,  // ✅ era só "value", API retorna "Amount"
  }));

export function useFuelData() {
  const [vehicleGroups,      setVehicleGroups]      = useState([]);
  const [vehicles,           setVehicles]           = useState([]);
  const [fuelTypes,          setFuelTypes]          = useState([]);
  const [refuelings,         setRefuelings]         = useState([]);

  const [selectedGroupId,    setSelectedGroupId]    = useState(0);
  const [selectedVehicleId,  setSelectedVehicleId]  = useState(null);

  const [isLoadingVehicles,   setIsLoadingVehicles]   = useState(false);
  const [isLoadingRefuelings, setIsLoadingRefuelings] = useState(false);
  const [isSaving,            setIsSaving]            = useState(false);
  const [isDeleting,          setIsDeleting]          = useState(false);


  useEffect(() => { loadGroups(); loadFuelTypes(); }, []);

  useEffect(() => {
    setVehicles([]);
    loadVehiclesByGroup(selectedGroupId ?? 0);
  }, [selectedGroupId]);

  useEffect(() => {
    if (selectedVehicleId) loadRefuelings(selectedVehicleId);
    else setRefuelings([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVehicleId]);

  const loadGroups = async () => {
    try {
      const data = await vehicleGroupService.fetchGroups();
      setVehicleGroups(Array.isArray(data) ? data : []);
    } catch { setVehicleGroups([]); }
  };

  const loadVehiclesByGroup = async (groupId) => {
    setIsLoadingVehicles(true);
    try {
      const data = await vehicleService.fetchVehicles(groupId || 0);
      setVehicles(Array.isArray(data) ? data : []);
    } catch { setVehicles([]); }
    finally { setIsLoadingVehicles(false); }
  };

  const loadFuelTypes = async () => {
    try {
      const data = await fuelService.list();
      setFuelTypes(normalizeFuelTypes(data));
    } catch { setFuelTypes([]); }
  };

  const loadRefuelings = useCallback(async (vehicleId) => {
    setIsLoadingRefuelings(true);
    try {
      const data = await fuelService.getRefuelingsByVehicle(vehicleId);
      setRefuelings(normalizeRefuelings(data));
    } catch { setRefuelings([]); }
    finally { setIsLoadingRefuelings(false); }
  }, []);

  const saveRefueling = async (payload) => {
    setIsSaving(true);
    try {
      const result = await fuelService.addRefueling(payload);
      if (result !== null && selectedVehicleId)
        await loadRefuelings(selectedVehicleId);
      return result;
    } finally { setIsSaving(false); }
  };

  const deleteRefueling = async (payload) => {
    setIsDeleting(true);
    try {
      const result = await fuelService.deleteRefueling(payload);
      if (result !== null && selectedVehicleId)
        await loadRefuelings(selectedVehicleId);
      return result;
    } finally { setIsDeleting(false); }
  };

  return {
    vehicleGroups, vehicles, fuelTypes, refuelings,
    selectedGroupId,   setSelectedGroupId,
    selectedVehicleId, setSelectedVehicleId,
    isLoadingVehicles, isLoadingRefuelings,
    isSaving, isDeleting,
    saveRefueling, deleteRefueling,
  };
}
